import useAppState from 'context/useAppState';
import React, { useState } from 'react'
import { updateCardStatus } from "services/task";

function Toggle({ setactiveCard, selectedCard }: any) {
	const [activate, setactivate] = useState(true);
	const { setOpenPlanningAnimation, eventFetchedData } = useAppState("eventData");
	const {updateCard} = useAppState('cardWrapper')

	const onhandleChange = (arg: any) => {
		// setactivate(!activate);
		// setactiveCard(!activate);

		selectedCard.status = selectedCard.status == 'active' ? 'inactive' : 'active'

		const isActive = selectedCard?.status == 'active'
		setactivate((prevActivate) => !prevActivate);
		setactiveCard(isActive)

		const payload = {
			card_id: selectedCard._id,
			status: isActive
		}
		updateStatus(payload)
	};

	const updateStatus = async (payload: any) => {
		await updateCardStatus(eventFetchedData?._id, payload);
		updateCard(selectedCard._id, '')
	}

	return (
		<>
			<span className="text-sm text-[#475467]">
				<label className="inline-flex items-center cursor-pointer pointer-events-auto">
					<input
						type="checkbox"
						className="sr-only peer"
						// checked={activate}
						checked={selectedCard?.status == 'active'}
						onChange={onhandleChange}
					/>
					<div className="relative w-11 h-6 bg-[#e8e8e8] rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full border border-[#d3d3d3] peer-checked:after:border-white after:content-[''] after:absolute after:top-[1px] after:start-[1px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-[20px] after:w-[20px] after:transition-all dark:border-gray-600 peer-checked:bg-[#1E0AF5]"></div>
				</label>
			</span>
		</>
	)
}

export default Toggle;
